(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(document).ready(function() {
    $(document).on('click', '.t4s-swatch__item', function() {
      const variant_name = $(this).text();
      $(".indicator-number").html(variant_name == "12 Bières" ? "2 x" : "1 x");
      document.getElementById("box-option-" + (variant_name != "12 Bières" ? "2" : "1")).style.display = 'none';
      document.getElementById("box-option-" + (variant_name == "12 Bières" ? "2" : "1")).style.display = 'block';
    });

    $(document).on('click', '#open-image-preview-initiation', function(e) {
      e.stopPropagation();
      $("#modal-image-preview-initiation").show();
    });
    $(document).on('click', '#modal-image-preview-initiation .t4s-modal-close', function() {
      $("#modal-image-preview-initiation").fadeOut();
    });
    $(document).on("click", function (event) {
        if (!$(event.target).closest("#modal-image-preview-initiation .t4s-modal__content").length) {
            $("#modal-image-preview-initiation").fadeOut();
        }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
